<template>

<v-app>


<!-- {{itemRef}} -->
<!-- {{itemData}} -->

<v-dialog v-model="show" fullscreen transition="v-dialog-bottom-transition" :overlay=false>

<v-card>
  <v-card-row>
    <v-toolbar class="pink">
      <v-btn icon="icon" @click.native="close">
        <v-icon>close</v-icon>
      </v-btn>
      <!-- <v-toolbar-title>{{name}}</v-toolbar-title> -->
      <v-toolbar-title>{{data.name}}</v-toolbar-title>
      <!-- <v-btn class="white--text" flat="flat" @click.native="addStaff">Save</v-btn> -->
    </v-toolbar>
  </v-card-row>

  <v-container style="margin-top: -20px">
    <v-row row>
      <v-col xs12>

  <v-list two-line subheader>

    <v-subheader>Associazione</v-subheader>


    <v-list-item>
      <v-list-tile>
        <v-list-tile-action>
          <v-icon class="indigo--text">person</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Tipo di socio</v-list-tile-title>
          <v-list-tile-sub-title>{{data.type}}</v-list-tile-sub-title>
        </v-list-tile-content>
        <v-list-tile-action>
          <v-icon class="indigo--text" @click.native.stop="showStatus = true">edit</v-icon>
        </v-list-tile-action>
      </v-list-tile>
    </v-list-item>

    <v-list-item>
      <v-list-tile>
        <v-list-tile-action>
          <!-- <v-icon class="indigo--text">person</v-icon> -->
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Stato</v-list-tile-title>
          <v-list-tile-sub-title>{{translate(data.status)}}</v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list-item>

    <v-list-item>
      <v-list-tile>
        <v-list-tile-action>
          <!-- <v-icon class="indigo--text">event</v-icon> -->
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>
            <span v-if="data.accepted !== ''">{{message.accepted}} {{data.accepted}}</span>
            <span v-else>{{message.submitted}}</span>
            </v-list-tile-title>
          <v-list-tile-sub-title>Richiesta il {{data.requested}}</v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list-item>

    <v-divider></v-divider>
    <v-subheader>Pagamenti</v-subheader>

    <v-list-item>
      <v-list-tile>
        <v-list-tile-action>
          <v-icon class="indigo--text">payment</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Quota associativa {{currentYear}}</v-list-tile-title>
          <!-- <v-list-tile-sub-title v-if="payments[currentYear]">{{payments[currentYear].date}}</v-list-tile-sub-title>
          <v-list-tile-sub-title v-else>Non in regola</v-list-tile-sub-title> -->
          <v-list-tile-sub-title>{{paidCurrentFee}}</v-list-tile-sub-title>
        </v-list-tile-content>
        <v-list-tile-action>
          <v-icon class="indigo--text" @click.native.stop="showPayments = true">add_circle</v-icon>
        </v-list-tile-action>
      </v-list-tile>
    </v-list-item>

    <v-divider></v-divider>
    <v-subheader>Contatti personali</v-subheader>

    <v-list-item>
      <v-list-tile>
        <v-list-tile-action>
          <v-icon class="indigo--text">phone</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{data.mobile}}</v-list-tile-title>
          <v-list-tile-sub-title>Mobile</v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list-item>

    <!-- <v-divider inset></v-divider> -->

    <v-list-item>
      <v-list-tile>
        <v-list-tile-action>
          <v-icon class="indigo--text">mail</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{data.email}}</v-list-tile-title>
          <v-list-tile-sub-title>Personal</v-list-tile-sub-title>
        </v-list-tile-content>
        <v-list-tile-action>
          <!-- <v-icon>mode_edit</v-icon> -->
          <!-- <v-icon>chat</v-icon> -->
        </v-list-tile-action>
      </v-list-tile>
    </v-list-item>

    <!-- <v-divider inset></v-divider> -->

    <v-list-item>
      <v-list-tile>
        <v-list-tile-action>
          <v-icon class="indigo--text">location_on</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{data.street}}</v-list-tile-title>
          <v-list-tile-sub-title>{{data.city}}, {{data.postal}}</v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list-item>

    <v-divider></v-divider>
    <v-subheader>Anagrafica</v-subheader>

    <v-list-item>
      <v-list-tile>
        <v-list-tile-action>
          <v-icon class="indigo--text">person_outline</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{data.cf}}</v-list-tile-title>
          <v-list-tile-sub-title>{{data.birthday}}, {{data.birthcity}}</v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list-item>


  </v-list>

</v-col>
</v-row>
</v-container>

</v-card>

<v-snackbar v-model="error.show">
  {{error.message}}
  <v-btn flat class="blue--text" @click.native="error.show = false">Close</v-btn>
</v-snackbar>

  <!-- remove confirmation -->
  <v-dialog v-model="removeConfirmation">
    <v-card>
      <v-card-row>
        <v-card-title>Remove staff member?</v-card-title>
      </v-card-row>
      <v-card-row actions>
        <v-btn flat="flat" @click.native="removeConfirmation = false">Disagree</v-btn>
        <v-btn class="red" @click.native="removeStaff">Delete</v-btn>
      </v-card-row>
    </v-card>
  </v-dialog>


  <v-dialog v-model="showPayments">
    <v-card>
      <v-card-row>
        <v-card-title><strong>Add payment</strong></v-card-title>
      </v-card-row>
      <v-card-row>
     <v-card-text>
       <v-container fluid>
         <v-text-field v-model="pay.fee" label="Anno (quota associativa)" />
         <v-text-field v-model="pay.date" label="Data (gg/mm/aaaa)" />
         <v-text-field v-model="pay.amount" label="Euro" />
       </v-container>
     </v-card-text>
    </v-card-row>
    <v-card-row>
      <v-card-text>
        <div v-for="(payment, paymentFee) in data.payments">
          <strong>{{paymentFee}}</strong> &nbsp; {{payment.date}} &nbsp; {{payment.amount}} &euro;
        </div>
      </v-card-text>
    </v-card-row>
      <v-card-row actions>
        <v-btn class="" flat="flat" @click.native="showPayments = false">Close</v-btn>
        <v-btn class="red" @click.native="addPayment">Add</v-btn>
      </v-card-row>
    </v-card>
  </v-dialog>


  <v-dialog v-model="showStatus">
    <v-card>
      <v-card-row>
        <v-card-title><strong>Change status</strong></v-card-title>
      </v-card-row>
      <v-card-row>
     <v-card-text>
       <v-container fluid>
         <v-radio label="Active" primary v-model="data.status" value="active" light></v-radio>
         <v-radio label="Accepted" primary v-model="data.status" value="accepted" light></v-radio>
         <v-text-field v-if="data.status === 'accepted'" v-model="data.accepted" label="Ammissione il (gg/mm/aaaa)" />
         <v-text-field v-if="data.status === 'accepted'" v-model="data.requested" label="Richiesta il (gg/mm/aaaa)" />
         <v-radio label="Inactive" primary v-model="data.status" value="inactive" light></v-radio>
         <v-radio label="Submitted" primary v-model="data.status" value="submitted" light></v-radio>
         <v-radio label="Incomplete" primary v-model="data.status" value="incomplete" light></v-radio>
       </v-container>
     </v-card-text>
    </v-card-row>
      <v-card-row actions>
        <v-btn class="" flat="flat" @click.native="showStatus = false">Cancel</v-btn>
        <v-btn class="red" @click.native="changeMemberStatus">Change</v-btn>
      </v-card-row>
    </v-card>
  </v-dialog>

</v-dialog>




</v-app>

</template>

<script>
// Firebase
import firebase from '../modules/firebase'
// Store
import store from '../modules/store'
// Locale
import locale from '../modules/locale'

// Components
// import AdminToolbar from './AdminToolbar'

export default {
  components: {
    // 'admin-toolbar': AdminToolbar
  },
  props: ['itemData', 'itemRef', 'showDialog'],
  watch: {
    'itemData': function () {
      this.data = this.itemData
      // if (this.data.accepted === '') {
      //   this.data.accepted = 'Non ancora accettato'
      // }
      if (this.data.hasOwnProperty('payments')) {
        if (this.data.payments.hasOwnProperty(this.currentYear)) {
          this.paidCurrentFee = this.data.payments[this.currentYear].date
        }
      }
    },
    'itemRef': function () {
      this.ref = this.itemRef
    },
    'showDialog': function () {
      this.show = this.showDialog
    }
  },
  data () {
    return {
      data: {},
      currentYear: '2017',
      paidCurrentFee: 'Non in regola',
      showPayments: false,
      showStatus: false,
      accepted: '',
      pay: {
        fee: '',
        date: '',
        amount: ''
      },
      ref: '',
      show: '',
      store,
      snackbar: false,
      removeConfirmation: false,
      message: {
        accepted: 'Ammesso il',
        submitted: 'Non ancora ammesso'
      },
      error: {
        show: false,
        message: 'Name and Email are still empty.'
      },
      payments: {
        '2016': {date: '03/02/2016', amount: '35'},
        '2017': {date: '01/01/2017', amount: '35'}
      }
    }
  },
  computed: {
  },
  methods: {
    translate: function (text) {
      return locale.it.translate(text)
    },
    changeMemberStatus: function () {
      // if (this.accepted === '') {
      //   this.accepted = this.data.accepted
      // } else {
      //   this.data.accepted = this.accepted
      // }
      // this.data.accepted = this.accepted
      firebase.database().ref(this.store.rootRef).child(this.ref).update({
        status: this.data.status,
        accepted: this.data.accepted,
        requested: this.data.requested
      })
      this.showStatus = false
    },
    addPayment: function () {
      firebase.database().ref(this.store.rootRef).child(this.ref).child('payments/').child(this.pay.fee).set(
        {date: this.pay.date, amount: this.pay.amount}
      )
      .then(() => {
        if (this.pay.fee === this.currentYear && this.pay.amount !== '') {
          this.paidCurrentFee = this.pay.date
        }
        firebase.database().ref(this.store.rootRef).child(this.ref).child('payments/').once('value', (snapshot) => {
          this.data.payments = snapshot.val()
        })
        this.showPayments = false
        this.pay.fee = ''
        this.pay.amount = ''
        this.pay.date = ''
      })
    },
    addPaymentTest: function () {
      // var newPay = JSON.parse(JSON.stringify(this.pay))
      // this.payments.unshift(newPay)
      this.payments[this.pay.fee] = {date: this.pay.date, amount: this.pay.amount}
      if (this.pay.fee === this.currentYear && this.pay.amount !== '') {
        this.paidCurrentFee = this.pay.date
      }
      this.showPayments = false
      this.pay.fee = ''
      this.pay.amount = ''
      this.pay.date = ''
    },
    close: function () {
      this.show = false
      this.store.showDialog = false
    }
    // remove: function (item) {
    //   firebase.database().ref('users/').child(this.ref).remove()
    //   firebase.database().ref(this.rootRef).child(this.ref).remove()
    //   this.removeConfirmation = false
    //   this.showDialog = false
    // }
  },
  beforeMount: function () {
  },
  mounted: function () {
  }
}
</script>



// WEBPACK FOOTER //
// MemberItem.vue?af3f394a